module.exports = __webpack_public_path__ + "media/images/users-e2b762c7c6c3b98abebaa055983bbf32.svg";